<template>
  <b-card no-body>
    <b-card-body>
      <customer-prices-detail
        ref="customerPricingDetail"
        type="new"
        :submitting="submitting"
        @submit="preview"
      />
    </b-card-body>

    <b-modal
      size="xl"
      id="pricingPreview"
      @close="previewData = null"
      cancel-variant="outline-secondary"
      :ok-title="t('Confirm')"
      :cancel-title="t('Close')"
      centered
      :title="t('Customer Pricing Preview')"
      @ok="submit"
    >
      <b-overlay rounded="md" variant="transparent">
        <div class="mb-1 font-bold">
          {{
            $t('You are about to make changes to current prices, please check and confirm prices.')
          }}
        </div>
        <region-pricing-table-view v-if="previewData" :data="previewData" />
      </b-overlay>
    </b-modal>
  </b-card>
</template>

<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { BCard, BCardBody, BOverlay } from 'bootstrap-vue';
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
import CustomerPricesDetail from '@/views/pages/customers/CustomerPricesDetail.vue';
import RegionPricingTableView from '../providers/RegionPricingTableView.vue';

export default {
  components: {
    BCard,
    BCardBody,
    BOverlay,
    CustomerPricesDetail,
    RegionPricingTableView
  },
  mixins: [helper],
  data() {
    return {
      submitting: false,
      data: {},
      previewData: null,
      previewedFormData: null,
      openPreview: false
    };
  },
  methods: {
    preview(data) {
      this.submitting = true;
      useService.customerService
        .previewCustomerPricing({ ...data, customerId: this.$route.params.id })
        .then(response => {
          this.previewedFormData = response.data;
          this.previewData = response.data?.preview;

          this.$bvModal.show('pricingPreview');
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    submit() {
      if (!this.previewedFormData) return;
      const data = this.previewedFormData;

      this.submitting = true;
      useService.customerService
        .createPricing(data.id)
        .then(response => {
          this.showSuccessMessage(response.message || '');
          this.$refs.customerPricingDetail.resetForm();
          this.$router.push({
            name: 'customer_prices',
            params: { id: this.$route.params.id }
          });
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
